export function removeImages(document: Document) {
  const imageEls = document.querySelectorAll<HTMLImageElement>('img')
  for (const imageEl of imageEls) {
    imageEl.remove()
  }
}
